import { useAppSelector } from '#/store';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Role } from '../api/types/user';

interface SetUserPayload {
  givenName: string,
  familyName: string,
  email: string,
}

const userSlice = createSlice({
  name: 'user',
  initialState: {
    givenName: '',
    familyName: '',
    email: '',
    activeRole: 'administrator' as Role,
  },
  reducers: {
    setUser: (state, action: PayloadAction<SetUserPayload>) => {
      const { givenName, familyName, email } = action.payload;
      state.givenName = givenName;
      state.familyName = familyName;
      state.email = email;
    },
    setActiveRole: (state, action: PayloadAction<Role>) => {
      state.activeRole = action.payload;
    }
  }
});

export const { setUser, setActiveRole } = userSlice.actions;
export const useUserSlice = () => useAppSelector((state) => state.user);
export default userSlice.reducer;
